//------------------------
// unload characteristics
//------------------------
export default function unloadCharacteristics(obj) {
  console.log('--------------------------')
  console.log('IN unloadCharacteristics')
  // --------------------
  // remove char attribs
  // --------------------
  const char_array = ['str', 'con', 'dex', 'siz', 'int', 'pow', 'cha']
  const end_array = ['cur', 'rolled', 'improvs_tot', 'incr_percent', 'adjs_tot']
  //--------------------------
  // loop chars for character
  //--------------------------
  char_array.forEach((char) => {
    //---------------------------------------
    // loop ends for each char - delete char
    //---------------------------------------
    end_array.forEach((e) => {
      delete obj[char + '_' + e]
    })
  })
  //--------------------------------
  // delete integs tot for pow only
  //--------------------------------
  delete obj.pow_integs_tot
  //---------------------------
  // delete loss total for con
  //---------------------------
  delete obj.con_wounds_tot
  //-------------------
  // return updated obj
  //--------------------
  return obj
}
